import React, { memo, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../ReduxTool/store/hooks';
import { setModalHeaderFooter } from '../../../ReduxTool/Slice/CommonReducers/CommonReducers';
import { NewModal } from '../../../Components/New/Modal/NewModal';
import SettingUnits from './SettingUnits';
import { IconSave } from '../../../assests/icons/MapToolsIcons';
import { ModalId } from '../../../Components/New/Modal/ProfileModal/Const';

export type UnitFormState = {measurementSystem: "Metric" | "Imperial", energyUnit: "kWh" | "MWh", timeFormat: "12h" | "24h" };

function UnitsRegion() {
  const dispatch = useAppDispatch();
    const { user } = useAppSelector((state) => state.auth);
    const { modalid } = useAppSelector((state) => state.commonReducers.modal);

    // const [units, setUnits] = useState({ unitsType: "Imperial", LengthDistance: "Yard (yd)", MassWeight: "Pound (lb)", CapacityVolume: "Pint", Temperature: "Fahrenheit (°F)", Time: "Second (s)" })
    const [units, setUnits] = useState<UnitFormState>({ measurementSystem: "Metric",  energyUnit: "kWh", timeFormat: "12h", })

    const handleChange = (e: any) => {
      const { name, value } = e.target;
      setUnits((prev) => ({  ...prev,  [name]: value, }));
    };
    
    const closeModal = () => { 
        dispatch(setModalHeaderFooter({title: "", btnTxt: "", secondaryBtnTxt: "", isheader: false,modalid: "" }));
    };
      
    // const { form, errors, handleChange, submit,resetForm, loading} = useChangePassword(user.userid, closeModal);
  
    if (modalid !== "unitsandregion") return null;
  
    return (<>
      {  modalid === ModalId.UnitsAndRegion &&  <NewModal height={"fit-content"} maxheight={"none"} primaryBtnDisabled modalSize="md" name="Units & Region" btnName="Save" onClick={()=>{}} setIsCLose={closeModal} isAbleCLick={false}  
         primarylefticon={<IconSave />}   >
        <SettingUnits handleChange={(event: React.ChangeEvent<HTMLInputElement> ) => handleChange(event)} units={units} />
         </NewModal>}
      </>)
}

export default memo(UnitsRegion)
